import { FC } from 'react';
import { Messages } from '@marriott/mi-ui-library';
import { LegalConsentsAuthorModeAndApiErrorHandlerProps } from './LegalConsents.types';

const AUTHOR_MODE_MSG =
  'Legal Consents is currently in Author Mode. The component is using placeholder JSON from the UXL response. To view the final UI with live data, please publish the page.';

export const LegalConsentsAuthorModeAndApiErrorHandler: FC<LegalConsentsAuthorModeAndApiErrorHandlerProps> = ({
  isAuthorMode,
  isApiError,
  onApiError,
}) => {
  if (isAuthorMode) {
    return (
      <Messages messageType="warning" className="col my-2" messageHeading="In Author Mode">
        <p data-testid="legal-consents-author-mode-msg">{AUTHOR_MODE_MSG}</p>
      </Messages>
    );
  }

  if (isApiError) {
    return (
      onApiError?.() || (
        <Messages
          messageType="error-sev1"
          className="col my-2"
          messageText="Our Server is been stubborn. Please try again later." // TODO: english bleed error message
        />
      )
    );
  }

  return null;
};
